
import { Route, Routes, useLocation } from 'react-router-dom'
import Login from '../Pages/Login/Login'
import StudentDashboardPage from '../Pages/StudentDashboard/StudentDashboardPage'
import CommonLayout from '../Component/CommonLayout';
import { StudentFullProfile } from '../Pages/StudentDashboard/StudentFullProfile';
import OrganisationDashboardPage from '../Pages/Organization/OrganisationDashboardPage';
import { PaymentGuard, ProtectedRoutes, PublicRoute } from './ProtectedRoutes';
import RolesAndPermissions from '../Pages/Roles&Permissions/RolesAndPermissions';
import { PermissionManagement } from '../Features/PermissionManagement';
import { AdmissionForm } from '../Pages/AdmissionForm/AdmissionForm';
import { CourseDashboard } from '../Pages/CourseDashboard/CourseDashboard';
import SupportDekLogin from '../Pages/SupportDeskLogin/SupportDeskLogin';
import EnquiryDashboard from '../Pages/Enquiry/EnquiryDashboard';
import { ClassDashboard } from '../Pages/ClassDashboard/ClassDashboard';
import { PaymentSuccessPage } from '../Pages/PaymentPage/PaymentSuccessPage';
import { PaymentFailedPage } from '../Pages/PaymentPage/PaymentFailedPage';
import { ManageStudetnsFeeDashboard } from '../Pages/Manage_Fee_And_Accounts/StudentPaymentLedger/StudentsFeeDashboard';
import { EnquiryDashboardDetails } from '../Pages/EnquiryDashboard/EnquiryDashboard';
import { ContestantDashboard } from '../Pages/ContestManageMent/ContestantDashboard/ContestantDashboard';
import { ManageFeeScheduleAndDue } from '../Pages/Manage_Fee_And_Accounts/ManageFeeScheduled&Due/ScheduledFees&DueDashboard';
import { AddScheduledFee } from '../Pages/Manage_Fee_And_Accounts/ManageFeeScheduled&Due/AddScheduledFee&Due';
import ManageDiscounts from '../Pages/Manage_Fee_And_Accounts/ManageDiscounts/ManageDiscounts';
import { AddDiscount } from '../Pages/Manage_Fee_And_Accounts/ManageDiscounts/AddDiscount'
import { ImposeClassesFee } from '../Pages/Manage_Fee_And_Accounts/ImposeFeePlan/ImposeFeePlanDashboard';
import { AcademicFinanceDashboard, CourseFeeDashboard } from '../Features/AcademicFinanceDashboard';
import RemittanceTransactions from '../Pages/Manage_Fee_And_Accounts/ManageTransactions/RemittanceTransactions';
import ManageBankAccounts from '../Pages/Manage_Fee_And_Accounts/ManageBankAccounts/ManageBankAccounts';
import { ReceiveTransactions } from '../Pages/Manage_Fee_And_Accounts/ManageTransactions/ReceiveTransactions';
import AddStudentWiseFee from '../Pages/Manage_Fee_And_Accounts/ImposeFeePlan/AddStudentWiseFee';
import TransactionsLayouts from '../Pages/Manage_Fee_And_Accounts/ManageTransactions/TransactionLayout';
import { LiveFinanceDashboard } from '../Features/FinanceDashboard/LiveFinanceDashboard';
import AttendanceDashboard from '../Pages/HrManagement/AttendanceDashboard/AttendanceDashboard';
import { AnimatePresence, motion } from "framer-motion";
import HolidaysAndWorkingDaysDashboard from '../Pages/HrManagement/Holidays&WorkingDays/Holidays&WorkingDaysDashboard';
import AddHolidays from '../Pages/HrManagement/Holidays&WorkingDays/AddHolidays';
import { useState } from 'react';
import ImposeFeeApprovalsTemplateCourseWise from '../Pages/Manage_Fee_And_Accounts/SendApprovalFeeDetailsTemplates/ImposeFeeApprovalsTemplateCourseWise';
import DiscountFeeApprovalTemplates from '../Pages/Manage_Fee_And_Accounts/SendApprovalFeeDetailsTemplates/DiscountFeeApprovalsTemplate';
import ImposeFeeApprovalsTemplateStudentWise from '../Pages/Manage_Fee_And_Accounts/SendApprovalFeeDetailsTemplates/ImposeFeeApprovalTemplatesStudentWise';
import FeeApprovalThankYouPage from '../Pages/Manage_Fee_And_Accounts/SendApprovalFeeDetailsTemplates/FeeApprovalsThankYouPage';
import FeePlanCancelled from '../Pages/Manage_Fee_And_Accounts/SendApprovalFeeDetailsTemplates/FeeApprovalsCancelPage';
import ScheduleFeeApprovalsTemplateCourseWise from '../Pages/Manage_Fee_And_Accounts/SendApprovalFeeDetailsTemplates/ScheduleFeeApprovalCousewise';
import StudentPaymentTemlates from '../Pages/StudentsPaymentsTemplate/StudentsPaymentTemplate';
import { StudentPaymentSuccessPage } from '../Pages/PaymentPage/StudentFeePaymentSuccessPage';
import { StudentFeePaymentFailedPage } from '../Pages/PaymentPage/StudentFeePaymentFailed';
import InvalidPaymentLink from '../Pages/PaymentPage/InvalidPaymentLink';
import FeeDueReport from '../Pages/Manage_Fee_And_Accounts/FeeDueReports/FeeDueReports';
import CourseWiseLedgerReport from '../Pages/Manage_Fee_And_Accounts/CourseWiseLedgerReport/CourseWiseLedgerReport';
import AdmitCardArchive from '../Pages/AdmitCards/AdmitCardArchive/AdmitCardArchive';
import { OnlinePaymentReportDashboard } from '../Pages/Manage_Fee_And_Accounts/OnlinePaymentReport/OnlinePaymentReport';
import EmployeeDashboard from '../Pages/HrManagement/EmployeeManageMent/EmployeeDashboard';
import { EmployeeFullProfile } from '../Pages/HrManagement/EmployeeManageMent/EmployeeFullProfile';
import StudentFeePaymentTemplates from '../Pages/StudentsPaymentsTemplate/StudentPaymentFee';
import ActivitiesDashboard from '../Pages/ActivitiesManagement/ActivityDashboard/ActivitiesDashboard';
import ActivityDetailsList from '../Pages/ActivitiesManagement/ManageActivity/ActivityDetailsList';
import ActivityCreationManagementFlow from '../Pages/ActivitiesManagement/ActivityDashboard/ActivityCreationManagementFlow';
import ExceptionalCaseFeeDueApprovals from '../Pages/Manage_Fee_And_Accounts/SendApprovalFeeDetailsTemplates/ApprovalExceptionalFeeDueForActivity';
import DefaulterApprovalPage from '../Pages/StudentsPaymentsTemplate/DefaulterApprovalPage';
import LibraryDuesList from '../Pages/LibraryNOC/LibraryNocStudentsList';
import { PaymentFailedPageArct } from '../Pages/ARCT/Page/Payment/PaymentFailedArct';
import HeroSection from '../Pages/ARCT/Component/HeroSection/HeroSection';
import { PaymentSuccessPageArct } from '../Pages/ARCT/Page/Payment/PaymentSuccessArct';
import AboutSection from '../Pages/ARCT/Component/AboutSection/AboutSection';
import PrizeSection from '../Pages/ARCT/Component/PrizesSection/PrizesSection';
import Layout from '../Pages/ARCT/Component/Layout/Layout';
import RegistrationForm from '../Pages/ARCT/Page/Register/RegisterForm';
import ContestReport from '../Pages/ContestManageMent/ContestReports/ContestReport';
import { AdmissionFormBackup } from '../Pages/AdmissionForm/AdmissionFormBackup';
import StudentSelfAdmitCardGenerations from '../Pages/StudentsPaymentsTemplate/Student_self_pay_admit_card_generates';
import ManageDefaulters from '../Pages/StudentDashboard/ManageDefaulters';




const Routing = () => {
    const [zoomedOut, setZoomedOut] = useState(false);
    return (
        <>    <AnimatePresence mode="wait">
            <Routes>
                <Route path="/" element={<ProtectedRoutes element={<ProtectedRoutes element={<CommonLayout><EnquiryDashboardDetails /></CommonLayout>} />} />} />
                <Route path="/Login" element={<PublicRoute element={<Login />} />} />
                {/* Student Dashboard routes  */}
                <Route path="/studentDashboard" element={<ProtectedRoutes element={<CommonLayout><StudentDashboardPage /></CommonLayout>} />} />
                <Route path="/studentDashboard/StudentFullProfile" element={<ProtectedRoutes element={<CommonLayout><StudentFullProfile /></CommonLayout>} />} />

                {/* Finance Routes */}
                <Route path="/finance/live-dashboard" element={<ProtectedRoutes element={<CommonLayout><LiveFinanceDashboard /></CommonLayout>} />} />
                <Route path="/finance/payment-report" element={<ProtectedRoutes element={<CommonLayout><OnlinePaymentReportDashboard /></CommonLayout>} />} />
                <Route path="/finance/manage-fee" element={<ProtectedRoutes element={<CommonLayout><ManageStudetnsFeeDashboard /></CommonLayout>} />} />
                {/* <Route path="/finance/manage-fee-plan" element={<ProtectedRoutes element={<CommonLayout><FeePlanDashboard /></CommonLayout>} />} /> */}
                <Route path="/finance/manage-fee-scedule" element={<ProtectedRoutes element={<CommonLayout><ManageFeeScheduleAndDue /></CommonLayout>} />} />
                <Route path="/finance/add-fee-schedule/:id?" element={<ProtectedRoutes element={<CommonLayout><AddScheduledFee /></CommonLayout>} />} />
                <Route path="/finance/bank-accoutns" element={<ProtectedRoutes element={<CommonLayout><ManageBankAccounts /></CommonLayout>} />} />
                <Route path="/finance/manage-fee-discounts" element={<ProtectedRoutes element={<CommonLayout><ManageDiscounts /></CommonLayout>} />} />
                <Route path="/finance/impose-fee-plan" element={<ProtectedRoutes element={<CommonLayout><ImposeClassesFee /></CommonLayout>} />} />
                <Route path="/finance/add-student-fee-plan" element={<ProtectedRoutes element={<CommonLayout><AddStudentWiseFee /></CommonLayout>} />} />
                <Route path="/finance/add-discount" element={<ProtectedRoutes element={<CommonLayout><AddDiscount /></CommonLayout>} />} />
                <Route path="/manage-activities" element={<ProtectedRoutes element={<CommonLayout><ActivitiesDashboard /></CommonLayout>} />} />
                <Route path="/manage-activity/:id" element={<ProtectedRoutes element={<CommonLayout><ActivityDetailsList /></CommonLayout>} />} />
                <Route
                    path="/define-activity"
                    element={
                        <ProtectedRoutes
                            element={
                                <CommonLayout>
                                    <ActivityCreationManagementFlow />
                                </CommonLayout>
                            }
                        />
                    }
                />
                <Route
                    path="/manage-library-noc"
                    element={
                        <ProtectedRoutes
                            element={
                                <CommonLayout>
                                    <LibraryDuesList />
                                </CommonLayout>
                            }
                        />
                    }
                />


                <Route
                    path="/define-activity/:id"
                    element={
                        <ProtectedRoutes
                            element={
                                <CommonLayout>
                                    <ActivityCreationManagementFlow />
                                </CommonLayout>
                            }
                        />
                    }
                />


                <Route path="/finance" element={<ProtectedRoutes element={<CommonLayout><TransactionsLayouts /></CommonLayout>} />}>
                    <Route path="transactions" element={<ReceiveTransactions />} />
                    <Route path="remittances" element={<RemittanceTransactions />} />
                </Route>
                <Route path="/finance/dashboard" element={<ProtectedRoutes element={<CommonLayout><LiveFinanceDashboard /></CommonLayout>} />} />
                <Route path="/finance/academic-dashboard" element={<ProtectedRoutes element={<CommonLayout><AcademicFinanceDashboard /></CommonLayout>} />} />
                <Route path="/finance/course-fee-dashboard" element={<ProtectedRoutes element={<CommonLayout><CourseFeeDashboard /></CommonLayout>} />} />


                <Route path="/finance/fee-due-report" element={<ProtectedRoutes element={<CommonLayout><FeeDueReport /></CommonLayout>} />} />
                <Route path="/finance/course-ledger-report" element={<ProtectedRoutes element={<CommonLayout><CourseWiseLedgerReport /></CommonLayout>} />} />
                <Route path="/admit-cards/archive" element={<ProtectedRoutes element={<CommonLayout><AdmitCardArchive /></CommonLayout>} />} />
                <Route path="/fee/impose-aprrovals-course-wise/:uniqueId" element={<ImposeFeeApprovalsTemplateCourseWise />} />
                <Route path="/fee/impose-aprrovals-student-wise/:uniqueId" element={<ImposeFeeApprovalsTemplateStudentWise />} />



                <Route path="/fee/schedule-aprrovals-course-wise/:uniqueId" element={<ScheduleFeeApprovalsTemplateCourseWise />} />
                {/* <Route path="/fee/schedule-aprrovals-student-wise/:uniqueId" element={<ScheduleFeeApprovalTemplatesStudentWise />} /> */}



                <Route path="/fee/discount-approvals/:uniqueId" element={<DiscountFeeApprovalTemplates />} />
                <Route path="/fee-approval-success" element={<FeeApprovalThankYouPage />} />
                <Route path="/fee-approval-cancel" element={<FeePlanCancelled />} />

                <Route path="/activity/exceptional-fee-due-approvals" element={<ExceptionalCaseFeeDueApprovals />} />
                <Route path="/student/defaulter-approval" element={<DefaulterApprovalPage />} />

                <Route
                    path="/student/fee-payment"
                    element={
                        <PaymentGuard>
                            <StudentPaymentTemlates />
                        </PaymentGuard>
                    }
                />

                <Route
                    path="/student/payment"
                    element={
                        <PaymentGuard>
                            <StudentFeePaymentTemplates />
                        </PaymentGuard>
                    }
                />
                <Route path="/student/fee/paymentsucess" element={<StudentPaymentSuccessPage />} />
                <Route path="/student/fee/paymentfailed" element={<StudentFeePaymentFailedPage />} />
                <Route path="/invalid-payment-link" element={<InvalidPaymentLink />} />
                <Route path="/admitcard/fee/payment" element={<StudentSelfAdmitCardGenerations />} />


                {/* Organisation Routes */}
                {/* <Route path="/OrganisationDashboard" element={<ProtectedRoutes element={<CommonLayout><OrganisationDashboardPage /></CommonLayout>} />} /> */}
                <Route path="/OrganisationDashboard" element={<ProtectedRoutes element={<CommonLayout><OrganisationDashboardPage /></CommonLayout>} />} />
                <Route path="/DesignationDashboard" element={<ProtectedRoutes element={<CommonLayout><RolesAndPermissions /></CommonLayout>} />} />
                <Route path="/permission-management" element={<ProtectedRoutes element={<CommonLayout><PermissionManagement /></CommonLayout>} />} />

                {/*Admission Form  */}
                <Route path="/AdmissionForm" element={<AdmissionForm />} />
                <Route path="/AdmissionForm/" element={<AdmissionForm />} />
                <Route path="/admissionForm-dev/" element={<AdmissionFormBackup />} />

                {/* Manage Defaulters */}
                <Route path="/manage-defaulters" element={<ProtectedRoutes element={<CommonLayout><ManageDefaulters /></CommonLayout>} />} />

                {/* Course */}
                <Route path="/courseDashboard" element={<ProtectedRoutes element={<CommonLayout><CourseDashboard /></CommonLayout>} />} />

                {/* Support Desk Login */}
                <Route path="/supportdesklogin" element={<SupportDekLogin />} />

                {/*Enquiry Dashboard  */}
                <Route path="/enquiry" element={<ProtectedRoutes element={<CommonLayout><EnquiryDashboard /></CommonLayout>} />} />
                <Route path="/enquiry-dashbord" element={<ProtectedRoutes element={<CommonLayout><EnquiryDashboardDetails /></CommonLayout>} />} />
                <Route path="/contest-list" element={<ProtectedRoutes element={<CommonLayout><ContestantDashboard /></CommonLayout>} />} />
                <Route path="/contest-reports" element={<ProtectedRoutes element={<CommonLayout><ContestReport /></CommonLayout>} />} />


                {/* Employeedashboard */}
                <Route path="/employeedashboard" element={<ProtectedRoutes element={<CommonLayout><EmployeeDashboard /></CommonLayout>} />} />
                <Route path="/employeedashboard/employeefullprofile" element={<ProtectedRoutes element={<CommonLayout><EmployeeFullProfile /></CommonLayout>} />} />

                {/* Class Dashboard */}
                <Route path="/classDashboard" element={<ProtectedRoutes element={<CommonLayout><ClassDashboard /></CommonLayout>} />} />


                {/* Payment Pages */}
                <Route path="/paymentsucess" element={<PaymentSuccessPage />} />
                <Route path="/paymentrejected" element={<PaymentFailedPage />} />


                <Route
                    path="/attendanceDashboard"
                    element={
                        <ProtectedRoutes
                            element={
                                zoomedOut ? (
                                    <AttendanceDashboard zoomedOut={zoomedOut} setZoomedOut={setZoomedOut} />
                                ) : (
                                    <CommonLayout>
                                        <AttendanceDashboard zoomedOut={zoomedOut} setZoomedOut={setZoomedOut} />
                                    </CommonLayout>
                                )
                            }
                        />
                    }
                />

                <Route path="/work-schedule" element={<ProtectedRoutes element={<CommonLayout><HolidaysAndWorkingDaysDashboard /></CommonLayout>} />} />
                <Route path="/add-holidays" element={<ProtectedRoutes element={<CommonLayout><AddHolidays /></CommonLayout>} />} />

                {/* <Route
                    path="/attendanceReport"
                    element={
                        <motion.div
                            variants={pageVariants}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            transition={pageTransition}
                        >
                            <ProtectedRoutes element={<AttedanceReport />} />
                        </motion.div>
                    }
                /> */}








                {/* ARCT====================================================================
===================================================================================
=================================================================================================== */}
                <Route path="/arct/register" element={<RegistrationForm />} />

                {/* Home route with Layout wrapping HeroSection */}
                <Route
                    path="/arct"
                    element={
                        <Layout>
                            <HeroSection />
                            <AboutSection />
                            <PrizeSection />
                            {/* Add other sections here like WhyArcT, PrizesSection */}
                        </Layout>
                    }
                />
                <Route path="/arct/paymentsucess" element={<PaymentSuccessPageArct />} />
                <Route path="/arct/paymentrejected" element={<PaymentFailedPageArct />} />

            </Routes>
        </AnimatePresence >
        </>
    )
}

export default Routing